import jsonp from 'jsonp';
import packageJson from '../package.json';
import {computeZtID, customExtend, formatURL, loadJSSDK} from './util';

const M_CONFIG = window.M_CONFIG || {};
const share = M_CONFIG.share || {};
const appVersion = window.navigator.appVersion;

const UA = {
    isUC: /ucbrowser/i.test(appVersion),
    isQQApp: /qq\//i.test(appVersion),
    isQQBrowser: /mqqbrowser/i.test(appVersion),
    isWeChat: /micromessenger/i.test(appVersion),
    isMApp:
        /mmq/i.test(appVersion) ||
        /gzq/i.test(appVersion) ||
        /pregnancyhelper/i.test(appVersion) ||
        /recordapp/i.test(appVersion)
};

const shareDefaultVal = {
    title: '妈妈网',
    desc: '妈妈网',
    link: window.location.href,
    imgUrl: `${window.location.protocol}//static-files.cdnmama.com/common/mama-logo.png`,
    wechatSignUrl: `${window.location.protocol}//weixin.mama.cn/wxapp/Api/common/getCommonSignPackage`,
    notEncodeShareURL: true,
    ztID: computeZtID(window.location.href),
    success: null,
    ready: null
};

// eslint-disable-next-line
function MShare(config, weChatConfig = {}) {
    const {openTagList, jssdkVersionConfig} = weChatConfig;
    this.weChat = Object.assign(
        {
            jsApiList: [
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'onMenuShareQQ',
                'onMenuShareWeibo',
                'onMenuShareQZone',
                'updateAppMessageShareData',
                'updateTimelineShareData'
            ]
        },
        {openTagList}
    );
    this.weChat.curTryCount = 0;
    this.share = customExtend(share, shareDefaultVal);
    // JSSDK 版本配置信息，包含 mama 和 wx 两个属性，分别对应 MJSSDK 和 WXMJSSDK
    this.jssdkVersionConfig = jssdkVersionConfig || {};
    this.updateConfig(config);
}

// 部分 App 和浏览器支持直接唤起分享的弹框, 此时不需要显示引导分享的弹窗
// 统一通过此方法来显示引导分享的弹窗, 会自动判断是显示弹窗还是直接唤起分享的弹框
MShare.prototype.showShareGuide = function (callback) {
    // App 升级到 x5 内核之后, UA 会包含 mqqbrowser, 因此需要先判断 isMApp
    if (UA.isMApp) {
        this.showShareGuide4MApp();
    }  else if (UA.isQQBrowser) {
        this.showShareGuide4QQBrowser();
    } else if (UA.isUC) {
        this.showShareGuide4UC();
    } else {
        if (callback) {
            callback();
        }
    }
};

MShare.prototype.showShareGuide4QQBrowser = function () {
    const shareInfo = {
        url: this.share.link,
        title: this.share.title,
        description: this.share.desc,
        img_url: this.share.imgUrl,
        img_title: this.share.title,
        content_type: 0
    };
    const success = () => {
        this.countShare('', this.share.ztID);
        if (this.share.success) {
            this.share.success();
        }
    };
    if (window?.browser?.app?.share) {
        window.browser.app.share(shareInfo, success);
    }
    if (window?.qb?.share) {
        window.qb.share(shareInfo, success);
    }
};

// 注意: 目前 UC 浏览器不支持分享缩略图的设置, 会自动对网页截图作为分享缩略图
MShare.prototype.showShareGuide4UC = function () {
    const shareInfo = [this.share.title, this.share.desc, this.share.link, '', '', '', ''];
    if (window?.ucbrowser?.web_share) {
        window.ucbrowser.web_share.apply(null, shareInfo);
    }
    if (window?.ucweb?.startRequest) {
        window.ucweb.startRequest('shell.page_share', shareInfo);
    }
};

MShare.prototype.showShareGuide4MApp = function () {
    window.MJSSDK.openSharePanel({
        title: this.share.title,
        desc: this.share.desc,
        link: this.share.link,
        imgUrl: this.share.imgUrl,
        success: (result) => {
            if (this.share.success) {
                this.share.success(result);
            }
        }
    });
};

MShare.prototype.updateConfig = function (config) {
    if (config) {
        this.share = customExtend(config, this.share);
    }

    this.share.link = formatURL(
        this.share.link.replace(/act(\d*).mama.cn\/subject\/(\d*\/)*/, function ($0, $1) {
            return `act${$1 ? $1 : ''}.mama.cn/subject/${new Date().getTime().toString().substring(3, 10)}/`;
        })
    );
    this.share.imgUrl = formatURL(this.share.imgUrl);

    // App 升级到 x5 内核之后, UA 会包含 mqqbrowser, 因此需要先判断 isMApp
    if (UA.isMApp) {
        this.initConfig4App();
    } else if (UA.isUC) {
        // UC 浏览器目前仅支持在调用 web_share 接口时自定义分享信息, 不支持单独设置
    } else if (UA.isWeChat) {
        this.getWeChatSign().then(() => {
            this.initConfig4WeChat();
        });
    } else if (UA.isQQBrowser) {
        this.initConfig4QQBrowser();
    } else if (UA.isQQApp) {
        this.getWeChatSign().then(() => {
            this.initConfig4QQ();
        });
    } else {
        // 未知的 UA 暂时不做处理
    }
};

MShare.prototype.initConfig4QQBrowser = function () {
    if (window.browser || window.qb) {
        const shareInfo = {
            url: this.share.link,
            title: this.share.title,
            description: this.share.desc,
            img_url: this.share.imgUrl,
            img_title: this.share.title
            // callback: () => {
            //     alert('initConfig4QQBrowser');
            // }
        };
        if (window?.browser?.app?.setShareInfo) {
            window.browser.app.setShareInfo(shareInfo);
        }
        if (window?.qb?.setShareInfo) {
            window.qb.setShareInfo(shareInfo);
        }
    } else {
        loadJSSDK('//jsapi.qq.com/get?api=app.share,app.setShareInfo').then(() => {
            this.initConfig4QQBrowser();
        });
    }
};

MShare.prototype.initConfig4QQ = function () {
    if (window.setShareInfo) {
        const shareInfo = {
            title: this.share.title,
            summary: this.share.desc,
            pic: this.share.imgUrl,
            url: this.share.link
        };

        shareInfo.WXconfig = {
            swapTitleInWX: false,
            appId: this.weChat.appId,
            timestamp: this.weChat.timestamp,
            nonceStr: this.weChat.nonceStr,
            signature: this.weChat.signature
        };

        shareInfo.callback = () => {
            if (this.share.success) {
                this.share.success();
            }
            this.countShare('', this.share.ztID);
        };

        window.setShareInfo(shareInfo);
    } else {
        loadJSSDK('//qzonestyle.gtimg.cn/qzone/qzact/common/share/share.js').then(() => {
            this.initConfig4QQ();
        });
    }
};

MShare.prototype.initConfig4WeChat = function () {
    if (window.wx) {
        const config = {
            debug: false,
            jsApiList: this.weChat.jsApiList,
            appId: this.weChat.appId,
            nonceStr: this.weChat.nonceStr,
            signature: this.weChat.signature,
            timestamp: this.weChat.timestamp,
            openTagList: this.weChat.openTagList || []
        };

        if (window.WeixinJSBridge) {
            window.wx.config(config);
            window.wx.ready(() => {
                if (this.share.ready) {
                    this.share.ready();
                }
                if (window.wx.onMenuShareTimeline) {
                    window.wx.onMenuShareTimeline(this.getWeChatConfig('cirfriend'));
                }
                if (window.wx.onMenuShareAppMessage) {
                    window.wx.onMenuShareAppMessage(this.getWeChatConfig('friend'));
                }
                if (window.wx.onMenuShareQQ) {
                    window.wx.onMenuShareQQ(this.getWeChatConfig('qq'));
                }
                if (window.wx.onMenuShareWeibo) {
                    window.wx.onMenuShareWeibo(this.getWeChatConfig('tencentweibo'));
                }
                if (window.wx.onMenuShareQZone) {
                    window.wx.onMenuShareQZone(this.getWeChatConfig('qqzone'));
                }
                if (window.wx.updateAppMessageShareData) {
                    window.wx.updateAppMessageShareData(this.getWeChatConfig('AppMessage'));
                }
                if (window.wx.updateTimelineShareData) {
                    window.wx.updateTimelineShareData(this.getWeChatConfig('Timeline'));
                }
            });
        } else {
            if (this.weChat.curTryCount < 10) {
                this.weChat.curTryCount++;
                setTimeout(() => {
                    this.initConfig4WeChat();
                }, 500);
            } else {
                console.warn('WeixinJSBridge initialization timeout.');
            }
        }
    } else {
        const version = this.jssdkVersionConfig.wx || '1.6.0';
        loadJSSDK(`//res.wx.qq.com/open/js/jweixin-${version}.js`).then(() => {
            setTimeout(() => {
                this.initConfig4WeChat();
            }, 1500);
        });
    }
};

MShare.prototype.initConfig4App = function () {
    if (window.MJSSDK) {
        window.MJSSDK.onMenuShare(this.share);
    } else {
        const version = this.jssdkVersionConfig.mama || '1.8.6';
        loadJSSDK(`//static.cdnmama.com/mfex/mjssdk/mjssdk-v${version}.js`).then(() => {
            this.initConfig4App();
        });
    }
};

MShare.prototype.getWeChatSign = function () {
    return new Promise((resolve, reject) => {
        const nowURL = encodeURIComponent(window.location.href.split('#')[0]),
            jsonpURL = `${this.share.wechatSignUrl}?nowUrl=${nowURL}`;
        jsonp(jsonpURL, {}, (err, res) => {
            const data = res.data;
            if (err) {
                reject(new Error('Get WeChat config failed.'));
                return;
            }
            if (res.code === 0) {
                this.weChat.appId = data.appId;
                this.weChat.timestamp = data.timestamp;
                this.weChat.nonceStr = data.nonceStr;
                this.weChat.signature = data.signature;
                resolve(this.weChat);
            } else {
                reject(new Error(res.msg));
            }
        });
    });
};

MShare.prototype.getWeChatConfig = function (type) {
    return {
        title: this.share.title,
        desc: this.share.desc,
        link: this.share.link,
        imgUrl: this.share.imgUrl,
        success: () => {
            let resType = 0;
            if (type === 'cirfriend') {
                resType = 2;
            } else if (type === 'friend') {
                resType = 1;
            } else if (type === 'qq') {
                resType = 6;
            } else if (type === 'qqzone') {
                resType = 4;
            } else if (type === 'tencentweibo') {
                resType = 5;
            }
            if (type === 'AppMessage' || type === 'Timeline') {
                if (this.share.success) {
                    console.log('配置 success 回调，只支持引 jweixin-1.3.2 或低于版本，请检查！');
                }
                return false;
            }
            this.countShare(type, this.share.ztID);
            if (this.share.success) {
                this.share.success({type: resType});
            }
        }
    };
};

MShare.prototype.countShare = function (type, ztID) {
    type = type || '';
    if (ztID) {
        const _img = new Image();
        _img.src = `//act.mama.cn/home/v6/share/index/count?parse=${type}&zt_id=${ztID}&callback=`;
    }
};

MShare.prototype.version = packageJson.version;

export default MShare;
